import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class CoreTemplateService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(source: any = 'all', query?: any) {
    return this.get('/v2/core/templates/' + source, query);
  }

  find(id) {
    return this.get('/v2/core/template/' + id);
  }

  create(body: any) {
    return this.post('/v2/core/template', body);
  }

  update(id, body: any) {
    return this.put('/v2/core/template/' + id, body);
  }

  _delete(id) {
    return this.delete('/v2/core/template/' + id);
  }

  deleteMany(body: any) {
    return this.post('/v2/core/template/delete-many', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/CoreTemplate.service.ts